var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.5C6 8.672 6 7.257 6.879 6.379C7.757 5.5 9.172 5.5 12 5.5H15C17.828 5.5 19.243 5.5 20.121 6.379C21 7.257 21 8.672 21 11.5V16.5C21 19.328 21 20.743 20.121 21.621C19.243 22.5 17.828 22.5 15 22.5H12C9.172 22.5 7.757 22.5 6.879 21.621C6 20.743 6 19.328 6 16.5V11.5Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5C5.20435 19.5 4.44129 19.1839 3.87868 18.6213C3.31607 18.0587 3 17.2956 3 16.5V10.5C3 6.729 3 4.843 4.172 3.672C5.343 2.5 7.229 2.5 11 2.5H15C15.7956 2.5 16.5587 2.81607 17.1213 3.37868C17.6839 3.94129 18 4.70435 18 5.5",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCopyIcon);
export default __webpack_public_path__ + "static/media/doubleCopyIcon.cee7509f73b6dfd50fa8859f41c3ea14.svg";
export { ForwardRef as ReactComponent };